export default __webpack_public_path__ + "3b960f89d8b52365d801a30f6b08f833.jpg";